import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { counterpartPath } from "../i18n";

const MARK = "data-hreflang";

// Writes hreflang alternates for the current EN/ES route pair.
const Hreflang = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    document.head.querySelectorAll(`link[${MARK}]`).forEach((el) => el.remove());
    const origin = window.location.origin;
    const es = pathname === "/es" || pathname.startsWith("/es/");
    const pairs = [
      ["en", es ? counterpartPath(pathname) : pathname],
      ["es", es ? pathname : counterpartPath(pathname)],
      ["x-default", es ? counterpartPath(pathname) : pathname],
    ];
    pairs.forEach(([lang, path]) => {
      const el = document.createElement("link");
      el.setAttribute("rel", "alternate");
      el.setAttribute("hreflang", lang);
      el.setAttribute("href", `${origin}${path}`);
      el.setAttribute(MARK, "");
      document.head.appendChild(el);
    });
  }, [pathname]);
  return null;
};

export default Hreflang;
